import axios from 'axios';
import { PUBLIC_PATHS } from '../utils/constants';

/**
 * dpp-client now talks to the P4 Rails API directly — the DPP Express proxy is
 * gone. `REACT_APP_P4_URL` is P4's base URL; auth rides on the httpOnly `jwt`
 * cookie P4 issues at login, so `withCredentials` must stay on.
 */
const request = axios.create({
    baseURL: process.env.REACT_APP_P4_URL,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
    }
});

/**
 * Normalizes P4 error responses. P4 renders every error as `{ errors: [...] }`
 * (array of strings) — or, for some validation failures, `{ errors: { field:
 * [...] } }`. This used to be done by DPP's errorHandler middleware; it now
 * lives here so call-sites get a flat `error.message` regardless of shape.
 */
function normalizeErrorMessage(error) {
    const errors = error.response?.data?.errors;

    if (Array.isArray(errors) && errors.length > 0) {
        return errors.join('; ');
    }
    if (typeof errors === 'string' && errors.length > 0) {
        return errors;
    }
    if (errors && typeof errors === 'object') {
        // Hash shape: { field: ['msg', ...] } -> "field msg; ..."
        const flattened = Object.entries(errors)
            .flatMap(([field, msgs]) => [].concat(msgs).map(m => `${field} ${m}`));
        if (flattened.length > 0) return flattened.join('; ');
    }
    return error.message || 'An internal error occurred.';
}

/** @see https://axios-http.com/docs/interceptors */
request.interceptors.response.use(succesfulResponse => succesfulResponse, function (error) {

    /**
     * @important this is JUST A HOTFIX. We should be using the history from createBrowserHistory, but we don't have access to it here due to it not being a component.
     * In reality, we should rewrite the entire fetch system elsewhere (maybe define it in a context provider in the App.js file, and pass down the request function to all children via props)
     * Additionally, we need to do some proper error handling for 404s, 500s, etc
     * That, however, goes WAY beyond the scope (and timeframe) of my changes.
     */
    console.log('REDIRECTION SWITCH IS ACTIVATING:');

    if (error.response) {
        // HTTP error response received
        console.log(error.response.status);
        switch (error.response.status){
            case 401: {
                if (PUBLIC_PATHS.includes(window.location.pathname)) break;
                const redirectTo = window.location.pathname + window.location.search + window.location.hash;
                window.location.assign(`/login?redirect_to=${encodeURIComponent(redirectTo)}`);
                break;
            }
            default:
                break;
        }
    } else if (error.request) {
        // Network error - no response received
        console.error('Network error: No response from server', error.request);
    } else {
        // Request setup error
        console.error('Request error:', error.message);
    }

    // Surface a clean, consistent message to call-sites (was DPP's errorHandler).
    error.normalizedMessage = normalizeErrorMessage(error);
    return Promise.reject(error);
})


export {request}
